import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import vuescroll from 'vuescroll';
import articleStore from '@/store';
import Mounter from '@/Mounter';
import MountPoints from '@/models/MountPoints';
import { Position, WidgetType } from '@/models/Enums';

Vue.config.productionTip = false;
Vue.filter(
  'formatPrice',
  (price: number): string => {
    const priceFormatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    });
    return priceFormatter.format(price);
  }
);
Vue.use(vuescroll);
Vue.use(Vuex);
const sharedStore = articleStore();
if (document.readyState === 'loading')
{
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}


// vm.$mount((window as any).dkVars.cameraWidgetMount);

function getMountPoints(mounter : Mounter) {
  const mountPoints = new MountPoints();
  // mountPoints.right.push(WidgetType.LocalShop);
  // mountPoints.right.push(WidgetType.Amazon);
  // return mountPoints;

  mountPoints.right.push(WidgetType.Dk);
  if (mounter.isAmazonRight()) {
    mountPoints.right.push(WidgetType.Amazon);
    if (mounter.doubleWidget()) {
      mountPoints.center.push(WidgetType.Amazon);
    }
  } else {
    mountPoints.center.push(WidgetType.Amazon);
  }
  mountPoints.right.push(WidgetType.LocalShop);
  mountPoints.center.push(WidgetType.Idealo);
  mountPoints.center.push(WidgetType.Dk);
  // mountPoints.center.push(WidgetType.WorkShop);
  return mountPoints;
}
function mount() {
  const mounter = new Mounter();
  const mountPoints = getMountPoints(mounter);

  mountPoints.right.forEach(type => {
    if (mounter.right != null) {
      injectInstance(mounter.right, Position.Side, type);
    }
  });

  mountPoints.center.forEach(type => {
    injectInstance(mounter.center, Position.Center, type);
  });
}

function injectInstance(el: HTMLElement, position: Position, type: WidgetType) {
  if ((window as any).dkVars.isDe) {
    const deAllowed = [WidgetType.Amazon];
    if (!deAllowed.includes(type)) {
      return;
    }
  }

  const injection = el.getElementsByClassName('widget-injection-point').item(0);
  if (injection == null) {
    // tslint:disable-next-line:no-console
    console.error('Can’t find injection point!');
    return;
  }

  if (injection instanceof HTMLElement) {
    injection.style.display = 'block';
  }
  const div = document.createElement('div');
  injection.appendChild(div);
  const data = () => {
    return {
      activePosition: position,
      type,
    };
  };
  const vue = new Vue({
    render: h => h(App),
    store: sharedStore,
    data,
    el: div,
  });
}

// https://codingexplained.com/coding/front-end/vue-js/mounting-templates-dynamically
